import React from 'react';



const AboutUs = () => {
  return (
    <section className="about-section py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="founders-image-container">
              <img 
                src="/images/IMG_5.jpg" 
                alt="" 
                className="founders-image img-fluid rounded-3"
              />
              <div className="experience-badge">
                <span>Gastón Cordoba, Abogado penalista</span>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <h2 className="section-title mb-4">
             
              <em>Conoce sobre nosotros</em>
            </h2>
            
            <div className="founders-story">
              <p className="lead highlight-text">
                <em><strong>"Bienvenidos a Estudio Jurídico Córdoba & Asociados, un espacio dedicado exclusivamente al ejercicio del derecho penal."
                  </strong></em>
                
              </p>
              <p className='story-text'>
                <em> Nuestra misión es brindar una representación legal <span className="highlight"> sólida, eficaz y respetuosa</span><strong><em></em></strong> garantizando una defensa de los derechos fundamentales en cada etapa del proceso penal.</em> 
              </p>
              
              <p className="story-text">
                En Córdoba y Asociados, nos especializamos en intervenciones desde la investigación penal 
                preparatoria hasta la ejecución de la pena, incluyendo juicios orales y públicos, planteo de recursos y acciones constitucionales
              </p>
              
              <p className="story-text">
                Además, ofrecemos asesoramiento integral en materia de expulsión de extranjeros y defensa penal especializada para personas extranjeras en la provincia de Córdoba.
              </p>
              
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;